import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pop-wrapper" }
const _hoisted_2 = { class: "pop-inner" }
const _hoisted_3 = { class: "pop-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "pop-content"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "本人郑重承诺提交的报名信息、参赛信息等全部信息真实有效，无任何虚假信息，无任何违背中华人民共和国相关法律法规的信息或行为，否则本人愿意承担因此产生的一切法律后果。", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "pop-content"
}
const _hoisted_10 = { key: 4 }
const _hoisted_11 = {
  key: 5,
  class: "pop-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightRules = _resolveComponent("RightRules")!
  const _component_CompetitionRules = _resolveComponent("CompetitionRules")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.type === 1)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "《诚信承诺条款》"))
          : _createCommentVNode("", true),
        (_ctx.type === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.type === 2)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, "《作品知识产权承诺书》"))
          : _createCommentVNode("", true),
        (_ctx.type === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_RightRules)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === 3)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, "《大赛规则》"))
          : _createCommentVNode("", true),
        (_ctx.type === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_CompetitionRules)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "pop-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, " 关  闭 ")
      ])
    ])
  ]))
}